import React, { Component, Fragment } from 'react';
import { Card, BreadCrumb, Confirm, Modal } from '../../components';
import { Translate } from '../../contexts/Language';
import DataTable from 'react-data-table-component'
import { DataTableColumns } from '../../config/DataTableColumns';
import { Service } from '../../services';
import { Config } from '../../config';
import Select from 'react-select';
import { ErrorMessage, Validator, VRules, VConditions } from '../../components/Validator';


export class BlackList extends Component {
    constructor(props) {
        super(props)

        this.Refs = React.createRef();

        this.state = {
            dataTable: {
                columns: DataTableColumns.transferOptionsBlackList,
                rows: []
            },
            formData: {
                transferOption: "",
                login: "",
                transferType: ""
            },
            validation: {
                error: false,
                message: ""
            }
        }

        this.onDelete = this.onDelete.bind(this);
        this.onEdit = this.onEdit.bind(this);

        this.typeOptions = [
            { value: 'W', label: "Withdrawal" },
            { value: 'D', label: "Deposit" },
            { value: 'B', label: "Both" }
        ];

        this.transferOptions = [];
    }
    componentDidMount() {
        this.onDataTable(true);
    }
    onDataTable(option) {

        Config.utilities.loadingFetch();

        Service.TransferOptions.BlackList().then(response => {
            if (response) {

                let dataTable = this.state.dataTable;

                dataTable.rows = response;

                this.setState({
                    dataTable: dataTable
                });

            }

            if (option) this.onTransferOptionList();

            Config.utilities.loadingFetch();
        });
    }
    onTransferOptionList() {


        Config.utilities.loadingFetch();

        Service.TransferOptions.TransferOptionList().then(response => {

            if (response) {

                this.transferOptions = response.map(item => ({ value: item.id, label: <span><img src={"/assets/psp-logo/" + (item.logo || "defaultlogo.svg")} alt="" width="20" className="mb-1" />&nbsp; {item.title}</span> }));
            }

            Config.utilities.loadingFetch();

        });
    }
    onFormChange(value, key) {

        let formData = this.state.formData;

        formData[key] = value;

        this.setState({
            formData
        });
    }
    onDelete(id) {

        Confirm({
            title: "Are you sure?",
            type: { warning: true },
            description: "The item will be deleted.",
            onConfirm: () => {

                Config.utilities.loadingFetch();

                Service.TransferOptions.BlackListDelete(id).then(response => {


                    Config.utilities.loadingFetch();

                    if (response) {
                        this.onDataTable();
                    }

                });

            },
            onCancel: () => {

            }
        });

    }
    onEdit(id) {

        Config.utilities.loadingFetch();

        this.setState(
            {
                modal: true,
                validation: {
                    error: false,
                    message: ""
                }
            });

        Service.TransferOptions.BlackListEdit(id).then(response => {

            if (response) {

                let formData = this.state.formData;

                formData.id = response.id;
                formData.login = response.login;
                formData.transferOption = this.transferOptions.filter(item => item.value === response.transferOption)[0];
                formData.transferType = this.typeOptions.filter(item => item.value === response.transferType)[0];

                this.setState({
                    formData
                });
            }

            Config.utilities.loadingFetch();
        });

    }
    onNew(modal) {
        this.setState({
            formData: {
                id: -1,
                transferOption: "",
                login: "",
                transferType: ""
            },
            modal: modal === false ? false : true,
            validation: {
                error: false,
                message: ""
            }
        });
    }
    onSave() {

        let formData = Object.assign({}, this.state.formData);

        formData.transferOption = formData.transferOption.value || "";
        formData.transferType = formData.transferType.value || "";

        if (this.isValid(formData)) {
            Config.utilities.loadingFetch();

            Service.TransferOptions.BlackListSave(formData).then(response => {

                if (response.error) {
                    this.setState({
                        validation: {
                            error: response.error,
                            message: response.message
                        }
                    });
                }
                else {
                    this.onNew(false);
                    this.onDataTable();
                }

                Config.utilities.loadingFetch();
            });
        }

    }
    isValid(data) {


        VRules["transferType"] = {
            Invalid: (value) => {
                return VConditions.Required(value)
            },
            Message: Translate("Please select Transfer Type!")
        }

        VRules["transferOption"] = {
            Invalid: (value) => {
                return VConditions.Required(value)
            },
            Message: Translate("Please select Transfer Option!")
        }


        let error = Validator.Valid(data, this.Refs);

        this.setState({
            validation: error
        });

        return !error.error;
    }
    render() {
        return (
            <Fragment>
                <BreadCrumb Title={Translate("Black List")} Name={Translate("Black List")} />
                <Modal Title={Translate("Edit Black List")} Show={this.state.modal} onClose={(e) => this.setState({ modal: false })}>
                    <div className="row mt-1 mb-1">
                        <p className="text-muted mb-2 ml-1 col-md-12 font-12">Role Information</p>
                        <div className="col-md-12">
                            <form className="form-horizontal" name="saveForm" ref={this.Refs}>
                                <ErrorMessage Validation={this.state.validation} />
                                <div className="form-group row ml-1 mr-1">
                                    <label htmlFor="login" className="col-sm-4 col-form-label">Login</label>
                                    <div className="col-sm-8">
                                        <input className="form-control" type="number" id="login" name="login" value={this.state.formData.login} onChange={(e) => this.onFormChange(e.target.value, "login")} />
                                    </div>
                                </div>
                                <div className="form-group row ml-1 mr-1">
                                    <label htmlFor="transferOption" className="col-sm-4 col-form-label">Transfer Option</label>
                                    <div className="col-sm-8">
                                        <Select
                                            id="transferOption"
                                            value={this.state.formData.transferOption}
                                            onChange={(option) => this.onFormChange(option, "transferOption")}
                                            options={this.transferOptions}
                                            isMulti={false}
                                            name="transferOption"
                                        />
                                    </div>
                                </div>
                                <div className="form-group row ml-1 mr-1">
                                    <label htmlFor="transferType" className="col-sm-4 col-form-label">Transfer Type</label>
                                    <div className="col-sm-8">
                                        <Select
                                            id="transferType"
                                            value={this.state.formData.transferType}
                                            onChange={(option) => this.onFormChange(option, "transferType")}
                                            options={this.typeOptions}
                                            isMulti={false}
                                            name="transferType"
                                        />
                                    </div>
                                </div>
                                <div className="form-group row ml-1 mr-1">
                                    <label htmlFor="save-form" className="col-sm-4 col-form-label"></label>
                                    <div className="col-sm-8">
                                        <button type="button" className="btn btn-info float-right" onClick={(e) => this.onSave()}><i className="far fa-save mr-1"></i> Save Form</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </Modal>
                <Card Title="Payment Service Black List" Description="Customer panel payment systems user black list.">
                    <div className="row">
                        <div className="col-md-12">
                            <button type="button" className="btn btn-info position-absolute add-new-button tabless" onClick={(e) => this.onNew()}><i className="fas fa-plus"></i> Add New Login</button>
                            {this.state.dataTable.rows.length === 0 ? (
                                <div className="alert alert-light" role="alert">
                                    <em><strong>No record!</strong> {Translate('No records found for the filter.')} </em>
                                </div>) :
                                (<DataTable
                                    noHeader={true}
                                    columns={this.state.dataTable.columns(this.onDelete, this.onEdit)}
                                    data={this.state.dataTable.rows}
                                    defaultSortField="id"
                                    defaultSortAsc={false}
                                    pagination
                                    highlightOnHover />)}
                        </div>
                    </div>
                </Card>
            </Fragment>
        )
    }
}